function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect, createContext, useContext, useMemo } from "react";
import PubSub from "../../utils/pubsub";
var TunnelContextInstance = /*#__PURE__*/ function(PubSub) {
    "use strict";
    _inherits(TunnelContextInstance, PubSub);
    function TunnelContextInstance() {
        var _this;
        _this = PubSub.call(this) || this;
        _this.tunnels = {};
        return _this;
    }
    return TunnelContextInstance;
}(PubSub);
var TunnelContext = /*#__PURE__*/ createContext(new TunnelContextInstance());
var add = function(context, tunnel) {
    var name = tunnel.name;
    if (!context.tunnels[name]) {
        // eslint-disable-next-line no-param-reassign
        context.tunnels[name] = [];
    }
    context.tunnels[name].push(tunnel);
    context.publish("tunnel-" + name + "-add", tunnel);
    return tunnel;
};
var remove = function(context, tunnel) {
    var _context_tunnels_name;
    var name = tunnel.name;
    for(var i = 0; i < ((_context_tunnels_name = context.tunnels[name]) == null ? void 0 : _context_tunnels_name.length); i += 1){
        if (tunnel === context.tunnels[name][i]) {
            var result = context.tunnels[name].splice(i, 1)[0];
            context.publish("tunnel-" + name + "-remove", result);
            break;
        }
    }
};
var useTunnel = function(param) {
    var name = param.name, beforeRef = param.beforeRef, afterRef = param.afterRef;
    var context = useContext(TunnelContext);
    var _useState = _sliced_to_array(useState(null), 2), cachedTunnel = _useState[0], setCachedTunnel = _useState[1];
    useEffect(function() {
        // Currently this event pattern is only useful if somewhere else this specific tunnel is removed
        var un = context.subscribe("tunnel-" + name + "-remove", function(tunnel) {
            setCachedTunnel(function(prevTunnel) {
                if (prevTunnel === tunnel) {
                    return null;
                }
                return prevTunnel;
            });
        });
        var addedTunnel = add(context, {
            name: name,
            beforeRef: beforeRef,
            afterRef: afterRef
        });
        setCachedTunnel(addedTunnel);
        return function() {
            if (addedTunnel) {
                remove(context, addedTunnel);
            }
            if (un && typeof un === "function") {
                un();
            }
        };
    }, [
        name,
        context
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return cachedTunnel;
};
var useTunnelView = function(param) {
    var name = param.name;
    var context = useContext(TunnelContext);
    var _useState = _sliced_to_array(useState(null), 2), cachedTunnel = _useState[0], setCachedTunnel = _useState[1];
    useEffect(function() {
        var _context_tunnels_name;
        var addUnsub = context.subscribe("tunnel-" + name + "-add", function(tunnel) {
            setCachedTunnel(function(prevTunnel) {
                // if no tunnel was available when mounting link to the first tunnel available
                return prevTunnel || tunnel;
            });
        });
        var removeUnsub = context.subscribe("tunnel-" + name + "-remove", function(tunnel) {
            setCachedTunnel(function(prevTunnel) {
                if (prevTunnel !== tunnel) {
                    return prevTunnel;
                }
                var size = context.tunnels[name].length;
                return size ? context.tunnels[name][size - 1] : null;
            });
        });
        if ((_context_tunnels_name = context.tunnels[name]) == null ? void 0 : _context_tunnels_name.length) {
            // If a tunnel exists with this name, use the most recent
            var size = context.tunnels[name].length;
            setCachedTunnel(context.tunnels[name][size - 1]);
        }
        return function() {
            if (addUnsub && typeof addUnsub === "function") {
                addUnsub();
            }
            if (removeUnsub && typeof removeUnsub === "function") {
                removeUnsub();
            }
        };
    }, [
        name,
        context
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return cachedTunnel;
};
var TunnelBarrier = function(param) {
    var children = param.children;
    var instance = useMemo(function() {
        return new TunnelContextInstance();
    }, []);
    return /*#__PURE__*/ _jsx(TunnelContext.Provider, {
        value: instance,
        children: children
    });
};
export { useTunnel, useTunnelView, TunnelBarrier };

//# sourceMappingURL=cache.js.map